import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { ProductSendToCompareComponent as OriginalComponent } from '../../shared/product-send-to-compare/product-send-to-compare.component';

@Component({
  selector: 'ish-lazy-product-send-to-compare',
  templateUrl: './lazy-product-send-to-compare.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyProductSendToCompareComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/compare/shared/product-send-to-compare/product-send-to-compare.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;



  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('compare').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../compare.module`).then(m => m.CompareModule);

    const { ProductSendToCompareComponent: originalComponent } = await import('../../shared/product-send-to-compare/product-send-to-compare.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.component.changeDetectorRef.markForCheck();
  }


}
